// JavaScript Document
// eslint-disable-next-line no-unused-vars
export default class Query {
  requestType = 0;
  filterArray = [];
  sortArray = [];
  whyNotRunnable = '';

  addFilterItem(field, value, type) {
    const obj = new Object();
    obj.field = field;
    obj.value = value;
    obj.type = type;
    this.filterArray.push(obj);
  }

  removeFilterItem(field) {
    for (let i = 0; i < this.filterArray.length; i++) {
      if (this.filterArray[i].field == field) {
        this.filterArray.splice(i, 1);
      }
    }
  }

  alterFilterItem(field, value, type) {
    let found = false;

    for (let i = 0; i < this.filterArray.length; i++) {
      if (this.filterArray[i].field == field) {
        this.filterArray[i].value = value;
        this.filterArray[i].type = type;
        found = true;
      }
    }

    if (!found) {
      const obj = new Object();
      obj.field = field;
      obj.value = value;
      obj.type = type;
      this.filterArray.push(obj);
    }
  }

  hasFilter(field) {
    let has = false;

    for (let i = 0; i < this.filterArray.length; i++) {
      if (this.filterArray[i].field == field) {
        has = true;
      }
    }
    return has;
  }

  hasFilterValue(field, value) {
    let has = false;

    for (let i = 0; i < this.filterArray.length; i++) {
      if (this.filterArray[i].field == field && this.filterArray[i].value == value) {
        has = true;
      }
    }
    return has;
  }

  runnable() {
    this.whyNotRunnable = '';
    let queryable = true;

    // look for conditions where we do not want to run the query
    if (this.filterArray.length == 0) {
      this.whyNotRunnable += 'Queries without filters are not allowed';
      queryable = false;
    }
    if (!this.hasFilter('w.contact_mc') && !this.hasFilter('w.bldg')) {
      this.whyNotRunnable += 'Queries for All Requesters and All Buildings are not allowed. Setting up User Buildings in the Prefrences allows for searching All Users and multiple buildings.';
      queryable = false;
    }

    return queryable;
  }

  addSortItem(value, order) {
    const obj = new Object();
    obj.value = value;
    obj.order = order;
    this.sortArray.push(obj);
  }

  removeSortItem(value) {
    for (let i = 0; i < this.sortArray.length; i++) {
      if (this.sortArray[i].value == value) {
        this.sortArray.splice(i, 1);
      }
    }
  }

  alterSortItem(value, order) {
    let found = false;

    for (let i = 0; i < this.sortArray.length; i++) {
      if (this.sortArray[i].value == value) {
        this.sortArray[i].order = order;
        found = true;
      }
    }

    if (!found) {
      const obj = new Object();
      obj.value = value;
      obj.order = order;
      this.sortArray.push(obj);
    }
  }

  hasSort(value) {
    let has = false;

    for (let i = 0; i < this.sortArray.length; i++) {
      if (this.sortArray[i].value == value) {
        has = true;
      }
    }
    return has;
  }

  hasSortOrder(value, order) {
    let has = false;

    for (let i = 0; i < this.sortArray.length; i++) {
      if (this.sortArray[i].order == order && this.sortArray[i].value == value) {
        has = true;
      }
    }
    return has;
  }
}

export { Query };
